<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-card class="elevation-2">

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="contactDialog"
              persistent
              max-width="300"
    >
      <v-card>
        <v-card-title class="text-h5 font-weight-regular">
         Contact info
        </v-card-title>
        <v-card-text v-if="orderData">
          <v-text-field
              prepend-icon="person"
              v-model="name"
              label="Full Name"
              type="text"
              required
          ></v-text-field>
          <v-text-field
              prepend-icon="email"
              v-model="email"
              :rules="emailRules"
              label="Email"
              type="text"
              required>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
              block
              text
              dark
              class="blue"
              :disabled="!contactValid"
              @click="saveClientInfo"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog  v-model="paymentDialog"
              persistent
              max-width="600"
    >
      <v-card class="elevation-1" v-if="transactionObj">
        <v-card-title >
          <v-icon>receipt</v-icon>
          {{transactionObj.paymentInfo.splitTitle}}
          ${{transactionObj.paymentInfo.splitAmount}}
        </v-card-title>
        <!--                                <v-btn @click="onlogout">logout</v-btn>-->
        <v-img
            class="mt-6"
            height="50"
            contain
            src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2Fstripe_logo_credit_card.png?alt=media&token=2e139d67-0ac6-4cf6-99ee-041e0560beb3"
        ></v-img>
        <v-card-title>Enter Card Details</v-card-title>

        <v-card-text>
          <stripe-element-card
              ref="elementRef"
              :pk="publishableKey"
              @token="tokenCreated"
              @element-change="cardStatus"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="!inputValid" class="mt-3 blue" block dark @click="submit">Charge Card</v-btn>
        </v-card-actions>
        <v-card-actions class="mb-3">
          <v-spacer></v-spacer>
          <v-btn block text @click="$router.push('/quotes/' + publicListingId + '/' + listingId + '/' + quoteId)">cancel</v-btn>
        </v-card-actions>
        <v-card-subtitle>Payment security provided by <a href="https://stripe.com/en-ca/privacy" class="black--text">Stripe.</a>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import {v1 as uuidv1} from "uuid";
import {doc, setDoc} from "firebase/firestore";
export default {
  components: {
    StripeElementCard,
  },
  props: ['quoteId', 'publicListingId', 'listingId'],
  data: () => ({
    contactDialog: false,
    name: null,
    email: null,
    transactionObj: null,
    orderData: null,
    clientInfoValid: false,
    paymentDialog: false,
    emailRules: [
      v => !!v || 'E-mail required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    publishableKey: 'pk_test_VSiz0KZwXiOcCozNlMssyig5',
    stripeObjChecked: false,
    // publishableKey: 'pk_live_IhMPCQ7scj4IOyljoFEkFxmv',
    token: null,
    inputValid: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    contactValid () {
      return this.name && this.email
    }
  },
  // watch: {
  //   email (value) {
  //     console.log(value)
  //   }
  // },
  created () {
    let paymentInfo  = this.$store.getters.transactionObj
    if (paymentInfo) {
      // console.log(paymentInfo)
      this.transactionObj = paymentInfo
      let orderObj = paymentInfo.orderData
      if (orderObj.clientInfo.name) {
        this.name = orderObj.clientInfo.name
      }
      if (orderObj.clientInfo.email) {
        this.email = orderObj.clientInfo.email
      }
      if (orderObj.clientInfo.email && orderObj.clientInfo.name) {
        this.paymentDialog = true
        this.clientInfoValid = true
      } else {
        this.contactDialog = true
      }
      this.orderData = paymentInfo.orderData
    }
    // console.log(paymentInfo)
  },
  methods: {
    submit () {
      // this will trigger the process
      this.$refs.elementRef.submit();
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    tokenCreated (token) {
      // console.log(this.user);
      let db = this.$store.state.db
      if (!this.transactionObj.invoiceObj.contactEmail) {
        this.transactionObj.invoiceObj.contactEmail = this.user.email
      }
      let transObj = {...this.transactionObj}
      transObj.invoiceObj.contactName = this.user.name
      transObj.invoiceObj.contactPhoneNumber = this.user.phoneNumber
      transObj.invoiceObj.publicListingId = this.publicListingId

      // console.log(transObj)
      let chargeObject = {chargeToken: token, ...transObj, chargeType: 'webBooking'}
      chargeObject.id = uuidv1()
      chargeObject.status = 'Pending'
      console.log(transObj)
      setDoc(doc(db, 'customers', this.user.uid, 'cardPayments', 'stripe', 'charges', chargeObject.id), chargeObject)
          .then(() => {
            this.$router.push('/transactionStatus/' + chargeObject.id)
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setError', err)
          })
      //this.$store.dispatch('newCardPaymentMade', chargeObject)
    },
    cardStatus (status) {
      this.inputValid = !!status.complete
    },
    saveClientInfo () {
      if (this.orderData.clientInfo) {
        this.orderData.clientInfo.name = this.name
        this.orderData.clientInfo.email = this.email
      }
      let userProfile = {...this.user}
      userProfile.email = this.email
      this.$store.dispatch('updateUserProfile', userProfile)
      this.contactDialog = false
      this.paymentDialog = true
    }
  }

}
</script>

